module.exports = __webpack_public_path__ + "static/media/blind-bid.5d3693ab.svg";